/**
 * TestOpsCommand — package entry component.
 *
 * Hosts wrap their route element with this. It sets up the
 * TestOpsCommandProvider with host-supplied dependencies, then renders
 * the inner TestOpsHub which contains the actual chat surface.
 *
 * Example:
 *   <TestOpsCommand
 *     user={{ id, full_name, email }}
 *     tenant={{ id, name }}
 *     AvatarComponent={AthenaLogo}
 *     ScreenshotComponent={ScreenshotImage}
 *     fetchPortfolios={(opts) => portfoliosApi.list(opts).then(r => r.portfolios)}
 *     fetchExecutionStatus={(id) => api.get(`/api/v1/executions/${id}`)}
 *   />
 */
import { TestOpsCommandProvider, type TestOpsCommandConfig } from './context'
import { TestOpsHub } from './TestOpsHub'

export type TestOpsCommandProps = TestOpsCommandConfig

export function TestOpsCommand(props: TestOpsCommandProps) {
  return (
    <TestOpsCommandProvider config={props}>
      <TestOpsHub />
    </TestOpsCommandProvider>
  )
}
